import {Button, ColourSolid} from "@twigsby/frontend-framework";
import {Controller, useFormContext} from "@twigsby/frontend-framework/lib/ReactHookForm";
import React from "react";

type IncludeExcludeType = {
    name: string;
    defaultValue: boolean;
}

const IncludeExclude = (props: IncludeExcludeType) => {
    const { control, getValues} = useFormContext();

    return (
        <Controller
            control={control}
            name={props.name}
            defaultValue={props.defaultValue}
            render={({ field, fieldState }) =>
                <div className={'btn-group m-0'} >
                    <Button
                        title={'Includes'}
                        fullWidth={true}
                        onClick={() => field.onChange(true)}
                        colour={getValues(props.name) ? ColourSolid.Selected : ColourSolid.Secondary } />
                    <Button
                        title={`Excludes`}
                        fullWidth={true}
                        onClick={() => field.onChange(false)}
                        colour={!getValues(props.name) ? ColourSolid.Selected : ColourSolid.Secondary } />
                </div>
            } />
    )
}

export { IncludeExclude }
